"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _BotContext = _interopRequireDefault(require("./BotContext"));

var _DefermentType = _interopRequireDefault(require("./types/DefermentType"));

var _react = _interopRequireWildcard(require("react"));

var _RenderMode = _interopRequireDefault(require("./types/RenderMode"));

var _DeferredRenderWrapper = _interopRequireWildcard(require("./DeferredRenderWrapper"));

var _intersectionObserver = require("./intersectionObserver");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Functional component definition of the Deferred Render This is the main function of the file.
 * Using memo so the component will not render until a parameter changes.
 *
 * A full render looks something like this:
 *
 *     <WrappingComponentType>
 *         <div {...props} />
 *     </WrappingComponentType>;
 *
 * The wrapping element can be set by the caller. The inner <div/> is a second wrapping layer
 * required for preserving the server-side render for certain render modes utilizing the `ref`
 * callback. The `ref` component and the preserved content component cannot be the same.
 *
 * The 'trick' for preserving the server-side render for these components comes down to using:
 *
 *     <div dangerouslySetInnerHTML={{ __html: '' }}` suppressHydrationWarning />
 *
 * These options cause React to skip checking or updating the component body but will still connect
 * this top level object to the DOM.
 */
// eslint-disable-next-line prefer-arrow-callback
function DeferredRender(_ref) {
  var isOnServerOverride = _ref.checkIsServerSideRender,
      children = _ref.children,
      _ref$delayTime = _ref.delayTime,
      delayTime = _ref$delayTime === void 0 ? 0 : _ref$delayTime,
      disabled = _ref.disabled,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? _RenderMode.default.RENDER_CLIENT_SIDE_ON_VISIBLE : _ref$mode,
      visibilityOptions = _ref.visibilityOptions,
      _ref$wrapperProps = _ref.wrapperProps,
      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
      _ref$WrappingComponen = _ref.WrappingComponentType,
      wrapperType = _ref$WrappingComponen === void 0 ? 'div' : _ref$WrappingComponen;
  // Determine if we're running on the server or not
  var isServerSide = isOnServerOverride ? isOnServerOverride() : (0, _utils.isOnServer)(); // Intersection Observer used to determine component visibility

  var observer = null; // Timeout ID used for rendering with a delay or immediately

  var timeoutID = -1; // Passable helper functions for cleaning up local variables in a consistent way to avoid
  // memory leaks

  var clearIntersectionObserver = function clearIntersectionObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  var clearTimeoutId = function clearTimeoutId() {
    if (timeoutID > -1) window.clearTimeout(timeoutID);
  }; // This callback function returns another function which allows us to clean up when the
  // component unmounts. This is equivalent to `componentDidUnmount` in class components. (See
  // https://reactjs.org/docs/hooks-effect.html). In this case, we want to clean up our
  // intersectionObserver and timeout to avoid memory leaks.


  (0, _react.useEffect)(function () {
    return function () {
      clearIntersectionObserver();
      clearTimeoutId();
    };
  }); // Grab the bot identifier from the context

  var _useContext = (0, _react.useContext)(_BotContext.default),
      isBot = _useContext.isSearchEngineCrawler; // Flag that triggers a full render set by certain modes on a previous renders, e.g., timer
  // or visibility-based rendering


  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shouldRerender = _React$useState2[0],
      setShouldRerender = _React$useState2[1]; // SERVER-SIDE RENDERING
  // ---------------------
  // Server side rendering is either enabled or disabled, and does not require a complex set
  // of conditions like client-side rendering does
  // Render server-side if we're on the server and ANY of the following are true:
  // - this component is disabled
  // - the render mode calls for server-side rendering
  // - this user identifies as a bot


  if (isServerSide && (disabled || (0, _utils.shouldServerSideRender)(mode, isBot))) {
    return (0, _DeferredRenderWrapper.default)({
      children: children,
      renderStrat: 'ssr',
      wrapperProps: wrapperProps,
      wrapperType: wrapperType
    });
  } // CLIENT-SIDE RENDERING
  // ---------------------
  // Determine the deferment type of this client side render


  var defermentType = (0, _utils.getClientSideRenderType)(mode, isBot); // A complete skip means to render nothing client-side

  if (defermentType === _DefermentType.default.COMPLETE_SKIP) return null; // Do an old-school blocking inline render if ANY of the following are true:
  // - this component is disabled
  // - the render mode calls for it explicitly
  // - a previous render has called for a rerender

  if (disabled || defermentType === _DefermentType.default.HYDRATE_INLINE_SLOW || shouldRerender) {
    return (0, _DeferredRenderWrapper.default)({
      children: children,
      renderStrat: 'inline',
      wrapperProps: wrapperProps,
      wrapperType: wrapperType
    });
  } // Do not hydrate the server-side rendered component, or render immediately client-side if
  // server-side rendering failed


  if (defermentType === _DefermentType.default.NEVER_HYDRATE) {
    var refCallback = function refCallback(el) {
      if (!el) return; // If the component is set to never hydrate, we would expect the HTML for this
      // component to have already been rendered server-side, If no children are present,
      // assume something went wrong, and render client-side immediately to recover.

      if ((0, _DeferredRenderWrapper.getWrapperElementChildren)(el) === null) {
        timeoutID = (0, _utils.setRenderOnTimeout)(setShouldRerender, 0);
      }
    };

    return (0, _DeferredRenderWrapper.DangerousDeferredRenderWrapper)({
      refCallback: refCallback,
      renderStrat: 'never'
    });
  } // Render the component when it becomes visible


  if (defermentType === _DefermentType.default.HYDRATE_ON_VISIBLE) {
    // A ref callback is executed after the actual render of the component and injects a
    // reference to the DOM element which is used by Intersection Observer to determine
    // component visibility.
    var _refCallback = function _refCallback(el) {
      if (!el) return; // Schedule the component for rendering once it becomes visible

      observer = (0, _intersectionObserver.createIntersectionObserver)(setShouldRerender, clearIntersectionObserver, (0, _intersectionObserver.getIntersectionObserverOpts)(visibilityOptions));
      observer.observe(el);
    };

    return (0, _DeferredRenderWrapper.DangerousDeferredRenderWrapper)({
      refCallback: _refCallback,
      renderStrat: 'on-visible',
      wrapperProps: wrapperProps,
      wrapperType: wrapperType
    });
  } // Eslint errors on this condition, "Unnecessary conditional, both sides of the expression
  // are literal values", even though neither side is literal. This is a bug that happens when
  // a condition handles the last of all enum items, DefermentType in this case. Technically
  // this `if` statement is not necessary, but it *is* intentional to avoid unexpected
  // behavior if we were to add/remove DefermentTypes. See the following for bug details:
  // https://github.com/typescript-eslint/typescript-eslint/issues/2952
  // eslint-disable-next-line zillow/@typescript-eslint/no-unnecessary-condition


  if (defermentType === _DefermentType.default.HYDRATE_ON_TIMER) {
    timeoutID = (0, _utils.setRenderOnTimeout)(setShouldRerender, delayTime);
    return (0, _DeferredRenderWrapper.DangerousDeferredRenderWrapper)({
      renderStrat: 'timeout',
      wrapperProps: wrapperProps,
      wrapperType: wrapperType
    });
  }

  var defermentString = defermentType; // eslint-disable-next-line no-console

  console.warn("Unhandled deferment type \"" + defermentString + "\". Falling back to inline rendering.");
  return (0, _DeferredRenderWrapper.default)({
    children: children,
    renderStrat: 'fallback',
    wrapperProps: wrapperProps,
    wrapperType: wrapperType
  });
}

var _default = /*#__PURE__*/_react.default.memo(DeferredRender);

exports.default = _default;